// Product data for the e-commerce store

// Static images for products - this is the recommended way in Vite
import autoStandarts from '../../assets/products/autostandarts.png';
import tintThumbnail from '../../assets/tint_thumbnail.png';
import applyTint from '../../assets/apply_tint_thumbnail.jpg';
import houseTint from '../../assets/house_tint_thumbnail.png';
import removeTint from '../../assets/remove_tint_thumbnail.jpg';
import ekaFrost from '../../assets/ekafrost.jpg';
import ekaGrafitti from '../../assets/ekagrafitti.jpg';
import ekaSecurity from '../../assets/ekasecurity.jpg';
import spogulis90_2stiklu from '../../assets/products/90_percent_2_stiklu_spogulpleve.png';
import spogulis75_2stiklu from '../../assets/products/75_percent_2_stiklu_spogulpleve.png';
import spogulis50_2stiklu from '../../assets/products/50_percent_2_stiklu_spogulpleve.png';
import spogulisMelns80_2stiklu from '../../assets/products/80_percent_melna_2_stiklu_spogulpleve.png';
import spogulisBronza80_2stiklu from '../../assets/products/80_percent_bronza_2_stiklu_spogulpleve.png';
import spogulisBronza70_2stiklu from '../../assets/products/70_percent_bronza_2_stiklu_spogulpleve.png';
import spogulis90_3stiklu from '../../assets/products/90_percent_3_stiklu_spogulpleve.png';
import spogulis75_3stiklu from '../../assets/products/75_percent_3_stiklu_spogulpleve.png';
import spogulis50_3stiklu from '../../assets/products/50_percent_3_stiklu_spogulpleve.png';

const products = [
  // Automotive Window Tinting Products
  {
    id: 'auto1',
    name: 'Standarta Auto Logu Plēve',
    category: 'automotive',
    price: 11.99,
    discountPrice: null,
    rating: 4.9,
    image: autoStandarts,
    priceUnit: 'par tekošo metru',
    description: 'Profesionāla tonēšanas plēve, dzidrs izskats, atstaro siltumu un UV starus. Standarta materiāls Latvijas klimatam.',
    features: [
      'Šī plēve ir pārāka par lielāko daļu pieejamajām budžeta plēvēm tirgū. Varat sagaidīt lielisku saraušanos sildot, ātru žūšanas laiku, ilgstošu krāsas noturību un pretbalēšanas tehnoloģiju. Ar šo plēvi par burbuļiem varat aizmirst - tās struktūra paredzēta ļoti ilgstošai noturībai. Ideāls risinājums standarta automašīnām - tā skaitā auto ar iebūvētām antenām, mobīlo sakaru un GPS sistēmām (plēve nebloķē iekārtu frekvences). 5 gadu garantija, pieejama 5%, 20%, 35% un 50% toņos (plašāka izvēle toņiem un izmēriem, kā arī tehniskā specifikācija, sazinoties info@notone.lv).',
    ],
    options: [
      { name: 'Gaišs (50%)' },
      { name: 'Vidēji Gaišs (35%)' },
      { name: 'Vidēji Tumšs (20%)' },
      { name: 'Tumšs (5%)' }
    ],
    widthOptions: [
      { value: '0.5', price: 11.99 },
      { value: '1.0', price: 14.99 },
      { value: '1.52', price: 9.99, minLength: 30 }
    ],
    stock: 50,
    bestseller: true
  },
  {
    id: 'auto2',
    name: 'Metalizēta Auto Logu Plēve',
    category: 'automotive',
    price: 16.99,
    discountPrice: 14.99,
    rating: 5.0,
    image: autoStandarts,
    priceUnit: 'par tekošo metru',
    description: 'Profesionāla tonēšanas plēve, lieliska siltuma atstarošana, kristāla dzidrums, izcila UV staru atstarošana.',
    features: [
      'Metalizēta logu plēve sniedz stipri lielāku siltuma atstarošanu par standarta auto logu plēvi, tās tehnoloģija izstrādāda 10+ gadu noturībai, nepazaudējot savas īpašības. Izcils materiāls, izcila veiktspēja. Ērta uzstādīšana un noņemšana pateicoties tās biezumam. 5 gadu garantija, pieejama 5%, 20%, 35% un 50% toņos (plašāka izvēle toņiem un izmēriem, kā arī tehniskā specifikācija, sazinoties info@notone.lv).'
    ],
    options: [
      { name: 'Gaišs (50%)' },
      { name: 'Vidēji Gaišs (35%)' },
      { name: 'Vidēji Tumšs (20%)' },
      { name: 'Tumšs (5%)' }
    ],
    widthOptions: [
      { value: '0.5', price: 14.99 },
      { value: '1.0', price: 16.99 },
      { value: '1.52', price: 10.99, minLength: 30 }
    ],
    stock: 30,
    bestseller: true
  },
  {
    id: 'auto3',
    name: 'Karbona Auto Logu Plēve',
    category: 'automotive',
    price: 19.99,
    discountPrice: null,
    rating: 4.9,
    image: autoStandarts,
    priceUnit: 'par tekošo metru',
    description: 'Profesionāla tonēšanas plēve ar izcilu izskatu, dzidrumu un siltuma atstarošanu. Pateicoties karbona tehnoloģijai, tā nebalē un nezaudē savas īpašības pat minimāli.',
    features: [
      'Karbona logu plēve ir populāra luksus klases automašīnu lokā, kur noturība, veiktspēja, izskats un siltuma atstarošana ir vissvarīgākais. 10 gadu garantija, pieejama 5%, 20%, 35% un 50% toņos (plašāka izvēle toņiem un izmēriem, kā arī tehniskā specifikācija, sazinoties info@notone.lv).',
    ],
    options: [
      { name: 'Gaišs (50%)' },
      { name: 'Vidēji Gaišs (35%)' },
      { name: 'Vidēji Tumšs (20%)' },
      { name: 'Tumšs (5%)' }
    ],
    widthOptions: [
      { value: '0.5', price: 19.99 },
      { value: '1.0', price: 21.99 },
      { value: '1.52', price: 17.99, minLength: 30 }
    ],
    stock: 100,
    bestseller: false
  },

  // Residential Window Tinting Products
  {
    id: 'res1',
    name: 'Spoguļplēve - 2 Stiklu Pakešu Logiem',
    category: 'residential',
    price: 24.99,
    discountPrice: 17.99,
    rating: 4.9,
    image: spogulis50_2stiklu,
    defaultImage: spogulis90_2stiklu,
    description: 'Premium spoguļplēve divu stiklu pakešu logiem, kas ievērojami samazina telpu pārkaršanu, aizsargā pret UV stariem un nodrošina izcilu privātumu dienas laikā.',
    features: [
      'Samazina telpu temperatūru vasarā līdz pat 8°C',
      'Bloķē 99% kaitīgo UV staru, pasargājot mēbeles un grīdas no izbalēšanas',
      'Nodrošina pilnīgu privātumu dienas laikā - no ārpuses redzams tikai spogulis',
      'Samazina elektroenerģijas patēriņu, samazinot kondicionieru izmantošanu',
      'Īpaši izstrādāta divu stiklu pakešu logiem, viegla uzstādīšana',
      '5 gadu garantija pret plēves izbalēšanu vai burbuļu veidošanos'
    ],
    options: [
      { 
        name: '10% Silver (Stiprs Spogulis)', 
        price: 0,
        image: spogulis90_2stiklu,
        description: 'Maksimāla siltuma atstarošana un privātums ar 90% atstarošanu. Augstas klases sudraba spoguļplēve ar izcilu spogulefektu no ārpuses.'
      },
      { 
        name: '15% Silver (Populārākais)', 
        price: 0,
        image: spogulis75_2stiklu,
        description: 'Laba siltuma atstarošana ar 75% atstarošanu. Vidēja intensitāte ar līdzsvarotu privātumu un gaismas caurlaidību.'
      },
      { 
        name: '50% Silver (Gaišs Spogulis)', 
        price: 0,
        image: spogulis50_2stiklu,
        description: 'Viegla siltuma atstarošana ar 50% atstarošanu. Minimāls spoguļefekts ar lielisku gaismas caurlaidību.'
      },
      { 
        name: '20% Melns Spogulis', 
        price: 2,
        image: spogulisMelns80_2stiklu,
        description: 'Ekskluzīva melnā spoguļplēve ar 80% atstarošanu. Stilīgs, moderns izskats ar lielisku siltuma atstarošanu.'
      },
      { 
        name: '20% Bronza Spogulis', 
        price: 2,
        image: spogulisBronza80_2stiklu,
        description: 'Premium bronzas spoguļplēve ar 80% atstarošanu. Elegants, siltāks izskats ar izcilu siltuma kontroli.'
      },
      { 
        name: '30% Gaišs Bronza Spogulis', 
        price: 2,
        image: spogulisBronza70_2stiklu,
        description: 'Vidēji intensīva bronzas spoguļplēve ar 70% atstarošanu. Pievilcīgs bronzas tonis ar labu siltuma kontroli.'
      }
    ],
    widthOptions: [
      { value: '1.52', price: 0 }
    ],
    maxLength: 30,
    minLength: 1,
    priceUnit: 'par tekošo metru',
    stock: 150,
    bestseller: true
  },
  {
    id: 'res2',
    name: 'Spoguļplēve - 3 Stiklu Pakešu Logiem (Līmē no Ārpuses)',
    category: 'residential',
    price: 26.99,
    discountPrice: 19.99,
    rating: 5.0,
    image: spogulis50_2stiklu,
    defaultImage: spogulis90_3stiklu,
    description: 'Speciāli izstrādāta spoguļplēve trīs stiklu pakešu logiem, kas montējama no ārpuses. Maksimāla siltuma atstarošana modernām mājām ar energoefektīviem logiem.',
    features: [
      'Samazina telpu temperatūru vasarā līdz pat 10°C',
      'Bloķē 99% kaitīgo UV staru',
      'Maksimāla siltuma aizsardzība īpaši karstām telpām',
      'Uzstādāma no ārpuses - īpaši izstrādāta trīs stiklu pakešu logiem',
      'Augsta izturība pret laikapstākļiem un ilgs kalpošanas laiks',
      '5 gadu garantija pret izbalēšanu, burbuļu veidošanos vai lobīšanos'
    ],
    options: [
      { 
        name: '10% Black Silver (Stiprs Spogulis)', 
        price: 0,
        image: spogulis90_3stiklu,
        description: 'Maksimāla siltuma atstarošana un privātums ar 90% atstarošanu. Augstas klases sudraba spoguļplēve ar izcilu spogulefektu no ārpuses.'
      },
      { 
        name: '15% Silver (Populārākais)', 
        price: 0,
        image: spogulis75_3stiklu,
        description: 'Laba siltuma atstarošana ar 75% atstarošanu. Vidēja intensitāte ar līdzsvarotu privātumu un gaismas caurlaidību.'
      },
      { 
        name: '50% Silver (Gaišs Spogulis)', 
        price: 0,
        image: spogulis50_3stiklu,
        description: 'Viegla siltuma atstarošana ar 50% atstarošanu. Minimāls spoguļefekts ar lielisku gaismas caurlaidību.'
      }
    ],
    widthOptions: [
      { value: '1.52', price: 0 }
    ],
    maxLength: 30,
    minLength: 1,
    priceUnit: 'par tekošo metru',
    stock: 100,
    bestseller: true
  },
];

// Generate length options from 1 to 30 meters
const generateLengthOptions = (maxLength = 30, minLength = 1) => {
  const options = [];
  for (let i = minLength; i <= maxLength; i++) {
    options.push({
      value: i.toString(),
      label: `${i}m`,
      price: i // Price scales linearly with length
    });
  }
  return options;
};

// Categories for filtering
const categories = [
  { id: 'all', name: 'Visi Produkti' },
  { id: 'automotive', name: 'Auto Plēves' },
  { id: 'residential', name: 'Mājokļu Plēves' }
];

// Featured products for the homepage
const featuredProducts = products.filter(product => product.bestseller);

export { products, categories, featuredProducts, generateLengthOptions }; 